import i18n from '@/libs/i18n'

const namespace = 'pages-comment'
const resource = 'comment'
export default [
  // *===============================================---*
  // *--------- Comment ---------------------------------------*
  // *===============================================---*
  {
    path: `/${resource}/list`,
    name: `${namespace}-list`,
    component: () => import('@/views/pages/comment/CommentList.vue'),
    meta: {
      resource,
      action: 'read',
      breadcrumb: [
        {
          text: i18n.t('general.list'),
          active: false,
          to: `/${resource}/list`,
        },
      ],
      pageTitle: i18n.t('comments.mainVerticalMenu.comments'),
    },
  },
  {
    path: `/${resource}/edit/:id`,
    name: `${namespace}-edit`,
    component: () => import('@/views/pages/comment/CommentEdit.vue'),
    meta: {
      resource,
      action: 'update',
      breadcrumb: [
        {
          text: 'ویرایش',
          active: false,
          to: `/${resource}/edit:id`,
        },
      ],
      pageTitle: 'دیدگاه ها',
    },
  },
]
